import { fg } from '@atlassian/jira-feature-gating';
import { transformToServer } from '@atlassian/jira-platform-utils-number';
import type { FormatConfigurationType } from '@atlassian/jira-platform-utils-number/src/ui/number-field-configuration/types.tsx';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraNumberFieldInput } from './types.tsx';

export const transformAsNumber = (value: string): number | undefined => {
	if (value) {
		return Number(value);
	}
	return undefined;
};

export const transformAsFormattedNumber = (
	value: string,
	fieldConfig?: { formatConfig?: FormatConfigurationType },
): number | undefined => {
	if (value && fg('frontier-currency-field-fix-percentage-storage')) {
		return transformToServer(Number(value), fieldConfig?.formatConfig?.formatStyle) ?? undefined;
	}

	if (value) {
		return Number(value);
	}
	return undefined;
};

export const mutateNumberField = (value: string, fieldId: string): JiraNumberFieldInput => ({
	fieldId,
	value: Number(value),
	mutationGroup: MUTATION_GROUP,
});

export const transformAsString = (value: number): string | undefined => {
	if (value !== undefined) {
		return String(value);
	}
	return undefined;
};
